/* Night Operators OPNVG-18 standalone Shopify lander. */
(function () {
  "use strict";
  var root = document.getElementById("no-gpnvg18");
  if (!root || root.dataset.ngReady) return;
  root.dataset.ngReady = "true";
  var VARIANTS = {
    Sand: { "1400-1550": "51823960883446", "1600-1800": "51823960916214", "1800-1950": "51823960948982", "2000-2100": "51823960981750" },
    Helmet: { "BLK-M": "51760827728118", "BLK-L": "51760827760886" }
  };
  var PRICES = { "1400-1550": 10999.95, "1600-1800": 12599.95, "1800-1950": 14699.95, "2000-2100": 15999.95 };
  var EXPLAINER = {
    "1400-1550": "Most buyers start here. Four Gen 2+ white phosphor autogated analog tubes.",
    "1600-1800": "For very dark skies with no moon. Upgrades all four tubes.",
    "1800-1950": "A higher FOM tier across all four tubes.",
    "2000-2100": "Sold out."
  };
  var HELMET_PRICE = 149.95;
  var HELMET_IMAGES = {"helmet": {"BLK": "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-blk.webp?v=1792014202", "TAN": "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-tan.webp?v=1792014222", "RG": "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-rg-nc1019.webp?v=1792014212"}, "helmet2": {"BLK": "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-detail.webp?v=1792014232", "TAN": "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-tan.webp?v=1792014222", "RG": "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-rg-nc1019.webp?v=1792014212"}};
  var state = { color: "Sand", fom: "1400-1550", helmet: false, size: "M", helmetColor: "BLK", busy: false };
  var stock = {};
  var tiers = Object.keys(PRICES);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.from(root.querySelectorAll(s)); };
  var fmt = function (n) { return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var available = function (fom) { return fom !== "2000-2100" && stock[VARIANTS[state.color][fom]] !== false; };
  /* round 4 (14 Oct 2026, Bon): we only sell the VENTED helmet now. COLOR-SIZE to variant id, read from the live
     helmet product, VENTED shell only, so a new vented colour or size shows up here by itself once it is in stock. */
  function noVented(p) {
    var out = {}; if (!p || !p.variants) return out;
    var names = (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).toUpperCase(); });
    var iS = names.indexOf("SIZE"), iC = names.indexOf("COLOR"), iH = names.indexOf("SHELL");
    if (iS < 0 || iC < 0 || iH < 0) return out;
    var SZ = { MEDIUM: "M", LARGE: "L" }, CO = { BLACK: "BLK", "RANGER GREEN": "RG", TAN: "TAN" };
    p.variants.forEach(function (v) {
      var o = v.options || [v.option1, v.option2, v.option3];
      if (String(o[iH]).toUpperCase() !== "VENTED") return;
      var z = SZ[String(o[iS]).toUpperCase()], c = CO[String(o[iC]).toUpperCase()];
      if (z && c) out[c + "-" + z] = String(v.id);
    });
    return out;
  }
  var helmetId = function () { return VARIANTS.Helmet[state.helmetColor + "-" + state.size]; };
  var helmetAvailable = function () { return stock[helmetId()] === true; };
  function classes(el, on, yes, no) {
    if (!el) return;
    (on ? no : yes).split(" ").forEach(function (c) { if (c) el.classList.remove(c); });
    (on ? yes : no).split(" ").forEach(function (c) { if (c) el.classList.add(c); });
  }
  var CHIP_ON = "border-accent text-accent bg-accent/10";
  var CHIP_OFF = "border-border text-muted-foreground hover:border-border-bright hover:text-foreground";
  var PILL_ON = "border-accent bg-accent/15 text-accent";
  var PILL_OFF = "border-transparent bg-background/30 text-muted-foreground hover:border-accent/40 hover:text-foreground";
  var PILL_SOLD = "border-transparent bg-background/20 text-muted-foreground/40 line-through cursor-not-allowed";
  function render() {
    if (!available(state.fom)) {
      var next = tiers.find(available);
      if (next) state.fom = next;
    }
    if (!helmetAvailable()) state.helmet = false;
    var canBuy = available(state.fom);
    var total = PRICES[state.fom] + (state.helmet ? HELMET_PRICE : 0);
    $$("[data-ng-color]").forEach(function (b) {
      var on = b.dataset.ngColor === state.color;
      classes(b, on, CHIP_ON, CHIP_OFF); b.setAttribute("aria-pressed", String(on));
    });
    $$("[data-ng-fom]").forEach(function (b) {
      var f = b.dataset.ngFom, on = f === state.fom, sold = !available(f);
      [PILL_ON, PILL_OFF, PILL_SOLD].forEach(function (cs) { cs.split(" ").forEach(function (c) { b.classList.remove(c); }); });
      (sold ? PILL_SOLD : on ? PILL_ON : PILL_OFF).split(" ").forEach(function (c) { b.classList.add(c); });
      b.disabled = sold; b.setAttribute("aria-disabled", String(sold)); b.setAttribute("aria-pressed", String(on && !sold));
      b.title = f + " FOM: " + fmt(PRICES[f]) + (sold ? ", sold out" : "");
      var price = b.querySelector("[data-ng-tier-price]");
      if (price) { price.textContent = fmt(PRICES[f]); price.classList.remove("text-muted-foreground/40", "text-accent/70", "text-muted-foreground/70"); price.classList.add(sold ? "text-muted-foreground/40" : on ? "text-accent/70" : "text-muted-foreground/70"); }
      var warning = b.querySelector("[data-ng-sold]") || Array.from(b.querySelectorAll("span")).find(function (s) { return s.textContent === "OUT OF STOCK"; });
      if (!warning) { warning = document.createElement("span"); warning.className = "block no-underline text-[9px] tracking-[0.16em] text-warning/80 mt-0.5"; warning.textContent = "OUT OF STOCK"; b.appendChild(warning); }
      warning.dataset.ngSold = ""; warning.hidden = !sold;
    });
    var expl = $("[data-ng-explainer]"); if (expl) expl.textContent = canBuy ? EXPLAINER[state.fom] : "This colour is currently out of stock.";
    var totalEl = $("[data-ng-total]"); if (totalEl) totalEl.textContent = fmt(total);
    var sub = $("[data-ng-addon-total]"); if (sub) { sub.hidden = !state.helmet; sub.textContent = "+" + fmt(HELMET_PRICE); }
    $$("[data-ng-cta]").forEach(function (b) {
      b.textContent = state.busy ? "Adding to cart..." : canBuy ? "Get The OPNVG-18" + (state.helmet ? " + Add-ons" : "") + ", " + fmt(total) + " →" : "Out of stock";
      b.disabled = state.busy || !canBuy; b.setAttribute("aria-busy", String(state.busy));
    });
    var toggle = $("[data-ng-toggle]");
    if (toggle) {
      toggle.title = helmetAvailable() ? "" : "Helmet stock unavailable"; toggle.disabled = !helmetAvailable(); toggle.setAttribute("aria-disabled", String(!helmetAvailable())); toggle.setAttribute("aria-checked", String(state.helmet));
      toggle.setAttribute("aria-label", helmetAvailable() ? "Add GEN II FAST SF VENTED HELMET" : "Helmet stock unavailable");
      classes(toggle, state.helmet, "border-accent bg-accent/30", "border-border-bright bg-background/60 hover:border-accent");
    }
    classes($("[data-ng-knob]"), state.helmet, "left-[calc(100%-1.125rem)] bg-accent shadow-[0_0_8px_hsl(var(--accent)/0.7)]", "left-[3px] bg-muted-foreground");
    classes($("[data-ng-row-title]"), state.helmet, "text-accent", "text-foreground");
    classes($("[data-ng-row-price]"), state.helmet, "text-accent", "text-muted-foreground");
    var hids = Object.keys(VARIANTS.Helmet).map(function (k) { return VARIANTS.Helmet[k]; });
    var hrow = $("[data-ng-open-helmet]"); if (hrow) hrow.style.display = (hids.length && hids.every(function (i) { return stock[i] === false; })) ? "none" : "";
    var row = $("[data-ng-open-helmet]"); if (row) { row.classList.toggle("opacity-40", !helmetAvailable()); row.title = helmetAvailable() ? "" : "Helmet stock unavailable"; }
    var rowPrice = $("[data-ng-row-price]"); if (rowPrice) rowPrice.textContent = helmetAvailable() ? "+" + fmt(HELMET_PRICE) : "OUT OF STOCK";
    $$("[data-ng-size],[data-ng-helmet-color]").forEach(function (b) {
      var isSize = b.hasAttribute("data-ng-size"), val = isSize ? b.dataset.ngSize : b.dataset.ngHelmetColor;
      var id = VARIANTS.Helmet[(isSize ? state.helmetColor : val) + "-" + (isSize ? val : state.size)];
      var sold = stock[id] !== true, on = val === (isSize ? state.size : state.helmetColor);
      classes(b, on, CHIP_ON, CHIP_OFF); b.setAttribute("aria-pressed", String(on)); b.setAttribute("aria-disabled", String(sold)); b.disabled = sold;
      b.classList.toggle("line-through", sold); b.classList.toggle("opacity-40", sold); b.title = sold ? "Helmet stock unavailable" : val;
      var gone = isSize ? (!id || stock[id] === false) : !["M", "L"].some(function (z) { var i2 = VARIANTS.Helmet[val + "-" + z]; return i2 && stock[i2] !== false; });
      b.style.display = gone ? "none" : "";
    });
    var thumb = $("[data-ng-thumb]"); if (thumb) thumb.src = HELMET_IMAGES.helmet[state.helmetColor];
    $$("[data-ng-helmet-image]").forEach(function (img) { img.src = (img.dataset.ngHelmetImage === "1" ? HELMET_IMAGES.helmet2 : HELMET_IMAGES.helmet)[state.helmetColor]; });
    var dcta = $("[data-ng-dialog-toggle]");
    if (dcta) { dcta.title = helmetAvailable() ? "" : "Helmet stock unavailable"; dcta.classList.toggle("opacity-40", !helmetAvailable()); dcta.setAttribute("aria-disabled", String(!helmetAvailable())); dcta.disabled = !helmetAvailable(); dcta.textContent = !helmetAvailable() ? "OUT OF STOCK" : state.helmet ? "✓ ADDED, " + fmt(HELMET_PRICE) : "+ ADD HELMET, " + fmt(HELMET_PRICE); classes(dcta, state.helmet, "bg-accent text-accent-foreground", "text-accent hover:bg-accent/10"); }
  }
  $$("[data-ng-color]").forEach(function (b) { b.addEventListener("click", function () { state.color = b.dataset.ngColor; render(); }); });
  $$("[data-ng-fom]").forEach(function (b) { b.addEventListener("click", function () { if (!available(b.dataset.ngFom)) return; state.fom = b.dataset.ngFom; render(); }); });
  function toggleHelmet(e) { if (e) e.stopPropagation(); if (!helmetAvailable()) return; state.helmet = !state.helmet; render(); }
  $$("[data-ng-toggle],[data-ng-dialog-toggle]").forEach(function (b) { b.addEventListener("click", toggleHelmet); });
  $$("[data-ng-size],[data-ng-helmet-color]").forEach(function (b) { b.addEventListener("click", function (e) { e.stopPropagation(); if (b.disabled) return; if (b.dataset.ngSize) state.size = b.dataset.ngSize; else state.helmetColor = b.dataset.ngHelmetColor; render(); }); });
  var lastFocus = null;
  function openDialog(d) { if (!d || d.open) return; lastFocus = document.activeElement; d.showModal(); var close = d.querySelector("[data-ng-close]"); if (close) close.focus(); }
  function closeDialog(d) { if (!d) return; d.close(); if (lastFocus) lastFocus.focus(); }
  var helmetDialog = $("[data-ng-helmet-dialog]"), opener = $("[data-ng-open-helmet]");
  if (opener) {
    opener.addEventListener("click", function (e) { if (e.target.closest("button")) return; openDialog(helmetDialog); });
    opener.addEventListener("keydown", function (e) { if (e.target !== opener) return; if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openDialog(helmetDialog); } });
  }
  $$("dialog").forEach(function (d) {
    d.addEventListener("click", function (e) { if (e.target !== d) return; var r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d); });
    d.addEventListener("cancel", function (e) { e.preventDefault(); closeDialog(d); });
    d.querySelectorAll("[data-ng-close]").forEach(function (b) { b.addEventListener("click", function () { closeDialog(d); }); });
  });
  $$("[data-ng-faq]").forEach(function (b) { b.addEventListener("click", function () {
    var wasOpen = b.getAttribute("aria-expanded") === "true";
    $$("[data-ng-faq]").forEach(function (other) {
      var on = other === b && !wasOpen, panel = other.nextElementSibling, plus = other.querySelector("span:last-child");
      other.setAttribute("aria-expanded", String(on)); if (panel) { panel.classList.toggle("max-h-[1400px]", on); panel.classList.toggle("pb-7", on); panel.classList.toggle("max-h-0", !on); }
      if (plus) plus.classList.toggle("rotate-45", on);
    });
  }); });
  var timer, atc = $("[data-ng-atc]"), kit = $("[data-ng-kit]");
  if (kit && atc) {
    kit.addEventListener("click", function () { atc.classList.remove("opacity-0", "pointer-events-none"); atc.classList.add("opacity-100", "pointer-events-auto"); atc.setAttribute("aria-hidden", "false"); atc.tabIndex = 0; clearTimeout(timer); timer = setTimeout(function () { atc.classList.add("opacity-0", "pointer-events-none"); atc.classList.remove("opacity-100", "pointer-events-auto"); atc.setAttribute("aria-hidden", "true"); atc.tabIndex = -1; }, 3000); });
    atc.addEventListener("click", function (e) { e.stopPropagation(); addToCart(); });
    atc.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); addToCart(); } });
  }
  async function addToCart() {
    if (state.busy || !available(state.fom)) return;
    if (state.helmet && !helmetAvailable()) { alert("That helmet is out of stock. Please choose another size or colour."); return; }
    var items = [{ id: VARIANTS[state.color][state.fom], quantity: 1, properties: { Colour: state.color, FOM: state.fom } }];
    if (state.helmet) items.push({ id: helmetId(), quantity: 1, properties: { Color: state.helmetColor, Size: state.size } });
    state.busy = true; render();
    try {
      var response = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) });
      if (!response.ok) throw new Error(await response.text());
      if (window.noCartDrawerOpen) { window.noCartDrawerOpen(await response.json().catch(function () { return null; })); } else { window.location.assign("/cart"); }
    } catch (error) { console.error("GPNVG cart failed", error); alert("Sorry, we could not add that to your cart. Please try again."); }
    finally { state.busy = false; render(); }
  }
  $$("[data-ng-cta]").forEach(function (b) { b.addEventListener("click", addToCart); });
  async function loadStock() {
    try {
      var r = await fetch("/products/gpnvg-18-panoramic-night-vision-goggle.js", { headers: { Accept: "application/json" }, cache: "no-store" });
      if (!r.ok) throw new Error("Stock unavailable: " + r.status);
      var product = await r.json();
      if (!Array.isArray(product.variants)) throw new Error("Stock response is invalid");
      product.variants.forEach(function (v) { if (typeof v.available === "boolean") stock[String(v.id)] = v.available; });
      render();
    } catch (error) { console.warn("GPNVG stock could not be checked. Shopify checks stock when adding to cart.", error); }
    // Helmet stock comes straight from the helmet product handle, like the live PVS export.
    var helmetController = new AbortController();
    var helmetTimeout = setTimeout(function () { helmetController.abort(); }, 10000);
    try {
      var hr = await fetch("/products/fast-sf-helmet.js", { headers: { Accept: "application/json" }, cache: "no-store", signal: helmetController.signal });
      if (!hr.ok) throw new Error("Helmet stock unavailable: " + hr.status);
      var helmet = await hr.json();
      if (!Array.isArray(helmet.variants)) throw new Error("Helmet stock response is invalid");
      helmet.variants.forEach(function (v) { if (typeof v.available === "boolean") stock[String(v.id)] = v.available; });
      var vm = noVented(helmet); Object.keys(vm).forEach(function (k) { VARIANTS.Helmet[k] = vm[k]; });
      if (!helmetAvailable()) { var firstOk = Object.keys(VARIANTS.Helmet).filter(function (k) { return stock[VARIANTS.Helmet[k]] === true; })[0]; if (firstOk) { state.helmetColor = firstOk.split("-")[0]; state.size = firstOk.split("-")[1]; } }
    } catch (error) { console.warn("Helmet stock could not be checked. Shopify checks stock when adding to cart.", error); }
    finally { clearTimeout(helmetTimeout); }
    render();
  }
  render(); loadStock();
})();
/* OPNVG-18 lander redesign 13 Oct 2026: panoramic video guards, field of view switch, callout lines. */
(function () {
  "use strict";
  var root = document.getElementById("no-gpnvg18");
  if (!root || root.dataset.gqReady) return;
  root.dataset.gqReady = "true";

  // 1. Looping panoramic video: plays only when a quarter of it is on screen; poster only for reduced motion.
  var video = root.querySelector(".gq-video");
  if (video) {
    video.muted = true; video.loop = true; video.playsInline = true;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var seen = true;
    var play = function () {
      if (reduce || !seen || document.hidden) return;
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    };
    if (reduce) { video.removeAttribute("autoplay"); video.pause(); }
    video.addEventListener("canplay", play);
    var firstTouch = function () { play(); document.removeEventListener("touchstart", firstTouch); };
    document.addEventListener("touchstart", firstTouch, { passive: true });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen = e.isIntersecting && e.intersectionRatio >= 0.25; if (seen) play(); else video.pause(); });
      }, { threshold: [0, 0.25, 0.5, 1] }).observe(video);
    } else play();
    document.addEventListener("visibilitychange", function () { if (document.hidden) video.pause(); else play(); });
  }

  // 2. Field of view switch: one window, three pictures, cross fade, caption per state.
  var card = root.querySelector("[data-gq-fovcard]");
  if (card) {
    var caps = {};
    try { caps = JSON.parse(card.querySelector("[data-gq-caps]").textContent); } catch (e) {}
    var btns = Array.from(card.querySelectorAll("[data-gq-sw]")), pics = Array.from(card.querySelectorAll("[data-gq-v]"));
    var cap = card.querySelector("[data-gq-cap]");
    var set = function (k) {
      btns.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.gqSw === k)); });
      pics.forEach(function (i) { i.classList.toggle("gq-on", i.dataset.gqV === k); });
      if (cap && caps[k]) cap.textContent = caps[k];
    };
    btns.forEach(function (b) { b.addEventListener("click", function () { set(b.dataset.gqSw); }); });
  }

  // 3. Callout lines: start on the card edge that faces the picture, end on the named part
  //    (anchor stored as a fraction of the picture's own pixels, mapped through object-fit contain).
  var how = root.querySelector("[data-gq-how]");
  if (how) {
    var lines = how.querySelector("[data-gq-lines]"), frame = how.querySelector("[data-gq-frame]"), pic = frame && frame.querySelector("img");
    var layout = function () {
      if (!lines || !pic) return;
      if (window.innerWidth < 768) { lines.innerHTML = ""; return; }
      var hb = how.getBoundingClientRect(), ib = pic.getBoundingClientRect();
      var nw = pic.naturalWidth || ib.width, nh = pic.naturalHeight || ib.height;
      if (!nw || !nh || !ib.width) return;
      var s = Math.min(ib.width / nw, ib.height / nh), cw = nw * s, ch = nh * s;
      var ox = ib.left + (ib.width - cw) / 2 - hb.left, oy = ib.top + (ib.height - ch) / 2 - hb.top;
      lines.setAttribute("viewBox", "0 0 " + hb.width + " " + hb.height);
      var out = "";
      how.querySelectorAll("[data-gq-callout]").forEach(function (c) {
        var cb = c.getBoundingClientRect(), hd = c.querySelector(".gq-cc-h").getBoundingClientRect();
        var x1 = cb.left - hb.left, y1 = hd.top + hd.height / 2 - hb.top;
        var x2 = ox + parseFloat(c.dataset.ax) * cw, y2 = oy + parseFloat(c.dataset.ay) * ch;
        var xm = x1 - Math.min(28, Math.max(0, (x1 - x2) / 3));
        out += '<polyline data-gq-line="' + c.dataset.gqCallout + '" points="' + x1.toFixed(2) + "," + y1.toFixed(2) + " " + xm.toFixed(2) + "," + y1.toFixed(2) + " " + x2.toFixed(2) + "," + y2.toFixed(2) + '"/>' +
          '<circle class="gq-lr" cx="' + x2.toFixed(2) + '" cy="' + y2.toFixed(2) + '" r="9"/><circle class="gq-ld" cx="' + x2.toFixed(2) + '" cy="' + y2.toFixed(2) + '" r="6"/>';
      });
      lines.innerHTML = out;
    };
    var raf = 0;
    var queue = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; layout(); }); };
    if (pic) pic.addEventListener("load", queue);
    window.addEventListener("resize", queue);
    window.addEventListener("scroll", queue, { passive: true });
    if ("ResizeObserver" in window) new ResizeObserver(queue).observe(how);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    layout();
  }
})();
